import { showConfirmCancelDialog, Utils } from 'app/main/components';
import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';
// eslint-disable-next-line import/no-cycle
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.ords_user_assigned_uid !== model.ords_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.ords_user_modified_uid,
						assignedTo: modifiedModel.ords_user_assigned_uid,
						title:
							import.meta.env.VITE_ENDPOINT === 'https://crm.borcianiebonazzi.com'
								? "Nuova Proposta d'Ordine assegnata"
								: 'Nuova Offerta assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.ords_title}".`,
						url: `${window.location.origin}/orders/details/${model.ords_uid}`,
						icon: 'basket',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const addOpportunityDialog: onAfterSaveType = ({ dispatch, model, modifiedModel, t }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.ords_orst_id === 4) {
			dispatch(
				showConfirmCancelDialog({
					title: t('ORDERS_DIALOG_TITLE_ADD_OPPORTUNITY'),
					onConfirm: () => {
						dispatch(
							showFastAddDialog({
								module: 'opportunities',
								model: {
									oppo_title: `Opportunità da ${model.ords_title}`,
									oppo_opst_id: 2,
									oppo_opty_id: 6,
									oppo_d_from: Utils.today().toDate(),
									oppo_value_planned: model.ords_tot_value_tax_excl,
									oppo_user_assigned_uid: model.ords_user_assigned_uid,
									oppo_user_assigned_2_uid: model.ords_user_assigned_2_uid,
									oppo_comp_uid: model.ords_comp_uid,
									oppo_peop_uid: model.ords_peop_uid,
									oppo_maac_uid: model.ords_maac_uid,
									oppo_dems_uid: model.ords_dems_uid,
									oppo_parent_oppo_uid: model.ords_oppo_uid,
									oppo_quot_uid: model.ords_quot_uid,
									oppo_cntr_uid: model.ords_cntr_uid,
									oppo_ords_uid: model.ords_uid,
									oppo_proj_uid: model.ords_proj_uid,
									oppo_acti_uid: model.ords_acti_uid,
									oppo_wore_uid: model.ords_wore_uid,
									oppo_chro_uid: model.ords_chro_uid,
									oppo_tick_uid: model.ords_tick_uid
								},
								onDialogClose: () => {
									resolve();
								}
							})
						);
					},
					onCancel: () => {
						dispatch(Utils.alertSuccessMsg(t));
						resolve();
					}
				})
			);
		} else resolve();
	});

const onAfterSave: onAfterSaveType = params =>
	DetailsEventsWrapper(params)([addOpportunityDialog, sendSaveNotification]);

export default { onAfterSave };
